import useTooltip from "../../../hooks/useTooltip.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlag } from "@fortawesome/pro-solid-svg-icons";

export default function RecommendationIndicator({ count }: { count: number }) {
  const tooltipRef = useTooltip<HTMLDivElement>();

  return (
    <div
      ref={tooltipRef}
      className="btn btn-sm text-muted"
      title={`${I18n.t("js.activitystreams.recommended")} (${count}x)`}
    >
      <FontAwesomeIcon icon={faFlag} />
    </div>
  );
}
